import React from 'react';
import {
  Text,
  Divider,
  Button,
  Heading,
  IconButton,
  InputRightElement,
  Input,
  InputGroup,
  InputLeftElement,
  Box,
  Flex,
  Icon,
} from '@podiumhq/design-system';

const FakeConversationList = () => {
  return (
    <Box
      minWidth="300px"
      maxWidth="375px"
      height="100%"
      width="33.33%"
      flex="0 0 auto"
      display="flex"
      flexDirection="column"
      borderRightWidth="1px"
      borderRightStyle="solid"
      borderRightColor="#e4e9f0"
      marginLeft="0"
      position="relative"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        margin="16px"
        marginTop="18px"
      >
        <Heading fontSize="xl" fontWeight="medium">
          All Conversations
        </Heading>
        <Button
          fillColor="black.base"
          iconSize="1rem"
          iconSpacing="2"
          rightIcon="ArrowDown"
          size="sm"
          variant="ghost"
          tabIndex="-1"
        >
          Newest
        </Button>
      </Box>
      <Box padding="8px">
        <Flex>
          <InputGroup size="sm">
            <InputLeftElement>
              <Icon type="Search" marginLeft="12px" />
            </InputLeftElement>
            <Input
              placeholder="Search messages"
              type="search"
              marginLeft="8px"
              variant="basic"
              size="sm"
              tabIndex="-1"
            />
            <InputRightElement>
              <IconButton type="XCircle" variant="ghost" tabIndex="-1" />
            </InputRightElement>
          </InputGroup>
          <IconButton
            fillColor="blue.base"
            size="sm"
            marginLeft="8px"
            iconSize="1.5em"
            type="Edit"
            tabIndex="-1"
          />
        </Flex>
      </Box>
      <Flex justifyContent="space-between">
        <Button
          fillColor="black.base"
          iconSize="1rem"
          iconSpacing="2"
          leftIcon="EmailOpen"
          size="sm"
          fontWeight="500"
          marginLeft="42px"
          marginTop="12px"
          variant="ghost"
          tabIndex="-1"
        >
          OPEN
        </Button>
        <Button
          fillColor="black.base"
          iconSize="1rem"
          iconSpacing="2"
          fontWeight="500"
          leftIcon="Check2"
          marginRight="42px"
          marginTop="12px"
          size="sm"
          variant="ghost"
          tabIndex="-1"
        >
          CLOSED
        </Button>
      </Flex>
      <Flex width="100%">
        <Divider borderBottomWidth="2px" borderColor="black.base" />
        <Divider />
      </Flex>
      <Box
        backgroundColor="blue.base"
        paddingLeft="32px"
        paddingTop="16px"
        paddingBottom="24px"
        paddingRight="32px"
      >
        <Flex justifyContent="space-between" alignItems="center">
          <Text color="silver.lighter" fontSize="lg" fontWeight="semibold">
            Channy Chan
          </Text>
          <Text color="silver.base" fontSize="sm">
            10:12 AM
          </Text>
        </Flex>
        <Text color="silver.base" paddingTop="4px">
          Hey! Can I get a ride to work? I only have...
        </Text>
      </Box>
    </Box>
  );
};

export default FakeConversationList;
